export default function TermsOfService() {
	return (
		<div className="flex-1 container mx-auto px-4 py-12 md:py-20 max-w-4xl">
			<div className="bg-white/60 dark:bg-black/20 backdrop-blur-md rounded-3xl p-8 md:p-12 border border-sky-900/10 dark:border-sky-100/10 shadow-sm">
				<h1 className="text-4xl md:text-5xl font-extrabold text-sky-950 dark:text-sky-50 mb-8">
					Terms of Service
				</h1>

				<div className="space-y-8 text-sky-900/80 dark:text-sky-100/70 leading-relaxed">
					<p className="font-medium text-lg">Last updated: {new Date().toLocaleDateString()}</p>

					<section className="space-y-4">
						<h2 className="text-2xl font-bold text-sky-900 dark:text-sky-100">1. Acceptance of Terms</h2>
						<p>
							By accessing or using BeeDiv ("the Service"), you agree to be bound by these Terms. If you
							disagree with any part of the terms, you may not access the Service.
						</p>
					</section>

					{/* CRITICAL FINANCIAL DISCLAIMER */}
					<section className="space-y-4 bg-sky-100/50 dark:bg-sky-900/20 p-6 rounded-2xl border border-sky-500/20">
						<h2 className="text-2xl font-bold text-sky-900 dark:text-sky-100 flex items-center gap-2">
							<span>⚠️</span> Financial Disclaimer
						</h2>
						<p className="font-semibold">
							BeeDiv is an informational tool for tracking and visualization purposes only.
						</p>
						<p>
							We are not financial advisors, and the content provided by the Service is{" "}
							<strong>not financial advice</strong>, recommendation, or solicitation to buy or sell any
							securities. All investment strategies and investments involve risk of loss. You are solely
							responsible for your investment decisions.
						</p>
					</section>

					<section className="space-y-4">
						<h2 className="text-2xl font-bold text-sky-900 dark:text-sky-100">3. User Accounts</h2>
						<p>
							You are responsible for safeguarding the password that you use to access the Service. You
							agree not to disclose your password to any third party. You must notify us immediately upon
							becoming aware of any breach of security or unauthorized use of your account.
						</p>
					</section>

					<section className="space-y-4">
						<h2 className="text-2xl font-bold text-sky-900 dark:text-sky-100">4. Third-Party Links</h2>
						<p>
							Our Service may contain links to third-party web sites or services (such as brokerage login
							pages via APIs) that are not owned or controlled by BeeDiv. We have no control over, and
							assume no responsibility for, the content, privacy policies, or practices of any third party
							web sites.
						</p>
					</section>

					<section className="space-y-4">
						<h2 className="text-2xl font-bold text-sky-900 dark:text-sky-100">5. Termination</h2>
						<p>
							We may terminate or suspend access to our Service immediately, without prior notice or
							liability, for any reason whatsoever, including without limitation if you breach the Terms.
						</p>
					</section>
				</div>
			</div>
		</div>
	)
}
